import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { composeFormData } from '@/utils'

import { NeighbourhoodPerk, useInvalidateNeighbourhoodPerks } from './get-neighbourhood-perks'

export interface SaveNeighbourhoodPerkRequest {
  buildingId: number
  category: string
  description: string
  image?: File
  link?: string
  logo?: File
  name: string
  tag: string
  url?: string
}

const MULTIPART = { headers: { 'content-type': 'multipart/form-data' } }

export const createNeighbourhoodPerk = async (data: SaveNeighbourhoodPerkRequest) => {
  const response = await authAPI.post<NeighbourhoodPerk>(
    '/Neighbourhood',
    composeFormData({ ...data }),
    MULTIPART,
  )
  return response.data
}

export const updateNeighbourhoodPerk = async ({
  id,
  ...data
}: SaveNeighbourhoodPerkRequest & { id: number }) => {
  const response = await authAPI.put<NeighbourhoodPerk>(
    `/neighbourhood/${id}`,
    composeFormData({ ...data }),
    MULTIPART,
  )
  return response.data
}

export const useCreateNeighbourhoodPerk = () => {
  const invalidatePerks = useInvalidateNeighbourhoodPerks()

  return useMutation({ mutationFn: createNeighbourhoodPerk, onSuccess: invalidatePerks })
}

export const useUpdateNeighbourhoodPerk = () => {
  const invalidatePerks = useInvalidateNeighbourhoodPerks()

  return useMutation({ mutationFn: updateNeighbourhoodPerk, onSuccess: invalidatePerks })
}
